import React from 'react';

import ChallengeBase from '../ChallengeBase'
import Seo from '../../components/Seo'

// missing SecurityMiddleware

// update challenge to ignore certain advice at certain steps

export const baseCode = [
  [
"We're getting ready to make the website production-ready. Make it run on HTTPS only",
`
INSTALLED_APPS = ['django.contrib.sessions', 'django.contrib.staticfiles']

MIDDLEWARE = [
    'django.middleware.security.SecurityMiddleware',
    'django.middleware.common.CommonMiddleware',
    'django.contrib.sessions.middleware.SessionMiddleware',
]

ROOT_URLCONF = 'config.urls'
`,
['C4008', 'C4009', 'C4012', 'C4014', 'C4004'],
[
  {
    href: 'https://dev.to/djangodoctor/hacking-django-websites-30f',
    text: 'Our blog post on Django security',
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/ref/middleware/#module-django.middleware.security',
    text: 'Django security documentation',
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/ref/middleware/#http-strict-transport-security',
    text: 'Django HSTS documentation',
  },
]
],
  [
"A user was victim of a clickjacking attack. How would you prevent this?",

`
INSTALLED_APPS = ['django.contrib.sessions', 'django.contrib.staticfiles']

MIDDLEWARE = [
    'django.middleware.security.SecurityMiddleware',
    'django.middleware.common.CommonMiddleware',
    'django.contrib.sessions.middleware.SessionMiddleware',
]

ROOT_URLCONF = 'config.urls'

`,
['C4010', 'C4011', 'C4017', 'C4012', 'C4004', 'C4009', 'C4014', 'C4013'],
[
  {
    href: 'https://dev.to/djangodoctor/django-hacking-clickjacking-4hg2',
    text: 'Our blog post on the clickjacking',
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/ref/clickjacking/',
    text: 'Django clickjacking documentation',
  },
]
],
  [
"You've seen evidence of Cross Site Request Forgery happening. How would you fix?",
`
INSTALLED_APPS = ['django.contrib.sessions', 'django.contrib.staticfiles']

MIDDLEWARE = [
    'django.middleware.security.SecurityMiddleware',
    'django.middleware.common.CommonMiddleware',
    'django.contrib.sessions.middleware.SessionMiddleware',
]

ROOT_URLCONF = 'config.urls'

`,
['C4008', 'C4010', 'C4011', 'C4017', 'C4012', 'C4004', 'C4014', 'C4013'],
[
  {
    href: 'https://dev.to/djangodoctor/hacking-django-websites-cross-site-request-protection-2i1i',
    text: 'Our blog post on CSRF',
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/ref/csrf/',
    text: 'Django CSRF documentation',
  },
  {
    href: 'https://owasp.org/www-community/attacks/csrf',
    text: 'OWASP CSRF documentation'
  }
]
],
  [
"A white hat hacker said your website is vulnerable to packet sniffing. Can you fix?",
`
INSTALLED_APPS = ['django.contrib.sessions', 'django.contrib.staticfiles']

MIDDLEWARE = [
    'django.middleware.security.SecurityMiddleware',
    'django.middleware.common.CommonMiddleware',
    'django.contrib.sessions.middleware.SessionMiddleware',
    'django.middleware.csrf.CsrfViewMiddleware',
]

ROOT_URLCONF = 'config.urls'

`,
['C4008', 'C4010', 'C4011', 'C4017', 'C4012', 'C4004'],
[
  {
    href: 'https://dev.to/djangodoctor/hacking-django-websites-stealing-sessions-with-packet-sniffing-n9k',
    text: 'Our blog post on the packet sniffing',
  },
  {
    href: 'https://dev.to/djangodoctor/hacking-django-websites-30f',
    text: 'Our blog post on Django security',
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/ref/middleware/#module-django.middleware.security',
    text: 'Django security documentation',
  },
]
],
  [
"A hacker hijacked a user's logged in session using an XSS attack. Can you prevent?",

`
INSTALLED_APPS = ['django.contrib.sessions', 'django.contrib.staticfiles']

MIDDLEWARE = [
    'django.middleware.security.SecurityMiddleware',
    'django.middleware.common.CommonMiddleware',
    'django.contrib.sessions.middleware.SessionMiddleware',
]

ROOT_URLCONF = 'config.urls'

SESSION_COOKIE_HTTPONLY = False
`,
['C4008', 'C4010', 'C4011', 'C4017', 'C4012', 'C4004', 'C4009', 'C4013', 'C4016'],
[
  {
    href: 'https://dev.to/djangodoctor/hacking-django-websites-session-hijacking-with-xss-2l8o',
    text: 'Our blog post on XSS attacks',
  },
  {
    href: 'https://dev.to/djangodoctor/hacking-django-websites-stealing-sessions-with-packet-sniffing-n9k',
    text: 'Our blog post on packet sniffing',
  },
  {
    href: 'https://en.wikipedia.org/wiki/Packet_analyzer',
    text: 'Wikipedia page for packet sniffing'
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/topics/http/sessions/',
    text: 'Django session documentation',
  },
  {
    href: 'https://docs.djangoproject.com/en/3.1/ref/middleware/#module-django.middleware.security',
    text: 'Django security documentation',
  },
]
],
]

// add XSS attack

export default function ChallengeModels(props) {
  return (
    <>
      <Seo title="Django code challenges: performance" />
      <ChallengeBase
        filepath='conf/settings.py'
        baseCode={baseCode}
        title='Django security challenge'
        category={'security'}
        {...props}
      />
    </>
  )
}